<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout">
      <div class="md-layout-item md-size-60 no-padding">
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>receipt_long</md-icon>
              학번별 통계
            </h4>
          </md-card-header>
          <md-card-content>
            <table class="flex-table td-text-align-left" style="margin-bottom: 5px;">
              <tr>
                <th star>회비년도</th>
                <td>
                  <input type="text" v-focus v-model="query.feeYear" v-mask="'####'" v-on:keyup.enter="searchQuery(1)">
                </td>
                <th star>회비구분</th>
                <td colspan="4">
                  <label><input type="radio" v-model="query.feeCd" value="10" v-on:keyup.enter="searchQuery(1)">일반회비</label>
                  <label><input type="radio" v-model="query.feeCd" value="11" v-on:keyup.enter="searchQuery(1)">평생회비</label>
                  <label><input type="radio" v-model="query.feeCd" value="12" v-on:keyup.enter="searchQuery(1)">분담금</label>
                </td>
                <md-button class="md-info md-sm full-size-button" @click="searchQuery(1)" style="margin-left: 5px;">
                    <md-icon>check</md-icon>검색
                  </md-button>
              </tr>
            </table>
            <md-table :value="hakbunDataList" class="paginated-table table-striped table-hover text-align-center h-scroll h720">
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="구분" v-bind:class="{sumary: isSumaryCheck(item.gubun), totSumary: isTotSumaryCheck(item.gubun)}" style="font-weight: bold;">{{ item.gubun }}</md-table-cell>
                <md-table-cell md-label="전체인원" v-bind:class="{sumary: isSumaryCheck(item.gubun), totSumary: isTotSumaryCheck(item.gubun)}" style="text-align: right; font-weight: bold;">{{ formatter.getCurrency(item.totCnt) }}</md-table-cell>
                <md-table-cell md-label="납입자수" v-bind:class="{sumary: isSumaryCheck(item.gubun), totSumary: isTotSumaryCheck(item.gubun)}" style="text-align: right; font-weight: bold;">{{ formatter.getCurrency(item.payCnt) }}</md-table-cell>
                <md-table-cell md-label="남자" v-bind:class="{sumary: isSumaryCheck(item.gubun), totSumary: isTotSumaryCheck(item.gubun)}" style="text-align: right;">{{ formatter.getCurrency(item.manCnt) }}</md-table-cell>
                <md-table-cell md-label="여자" v-bind:class="{sumary: isSumaryCheck(item.gubun), totSumary: isTotSumaryCheck(item.gubun)}" style="text-align: right;">{{ formatter.getCurrency(item.femaleCnt) }}</md-table-cell>
                <md-table-cell md-label="미상" v-bind:class="{sumary: isSumaryCheck(item.gubun), totSumary: isTotSumaryCheck(item.gubun)}" style="text-align: right;">{{ formatter.getCurrency(item.etcCnt) }}</md-table-cell>
                <md-table-cell md-label="지로납부" v-bind:class="{sumary: isSumaryCheck(item.gubun), totSumary: isTotSumaryCheck(item.gubun)}" style="text-align: right;">{{ formatter.getCurrency(item.jiroCnt) }}</md-table-cell>
                <md-table-cell md-label="송금" v-bind:class="{sumary: isSumaryCheck(item.gubun), totSumary: isTotSumaryCheck(item.gubun)}" style="text-align: right;">{{ formatter.getCurrency(item.transCnt) }}</md-table-cell>
                <md-table-cell md-label="카드" v-bind:class="{sumary: isSumaryCheck(item.gubun), totSumary: isTotSumaryCheck(item.gubun)}" style="text-align: right;">{{ formatter.getCurrency(item.creditCnt) }}</md-table-cell>
                <md-table-cell md-label="신규(모교)" v-bind:class="{sumary: isSumaryCheck(item.gubun), totSumary: isTotSumaryCheck(item.gubun)}" style="text-align: right;">{{ formatter.getCurrency(item.newkorCnt) }}</md-table-cell>
                <md-table-cell hidden></md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-size-40 no-padding">
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>receipt_long</md-icon>대학별 통계
            </h4>
          </md-card-header>
          <md-card-content>
            <table class="flex-table td-text-align-left" style="margin-bottom: 5px;">
              <tr>
                <th star>회비년도</th>
                <td>
                  <input type="text" v-model="query2.feeYear" v-mask="'####'" v-on:keyup.enter="searchQuery(2)">
                </td>
                <th star>회비구분</th>
                <td colspan="3">
                  <label><input type="radio" v-model="query2.feeCd" value="10" v-on:keyup.enter="searchQuery(2)">일반회비</label>
                  <label><input type="radio" v-model="query2.feeCd" value="11" v-on:keyup.enter="searchQuery(2)">평생회비</label>
                  <label><input type="radio" v-model="query2.feeCd" value="12" v-on:keyup.enter="searchQuery(2)">분담금</label>
                </td>
                <md-button class="md-info md-sm full-size-button" @click="searchQuery(2)" style="margin-left: 5px;">
                  <md-icon>check</md-icon>검색
                </md-button>
              </tr>
            </table>
            <md-table :value="collegeDataList" class="paginated-table table-striped table-hover text-align-center h-scroll h720">
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="구분" v-bind:class="{sumary: isSumaryCheck2(item.gubun), totSumary: isTotSumaryCheck2(item.gubun)}" style="font-weight: bold;">{{ item.gubun }}</md-table-cell>
                <md-table-cell md-label="통합단과대학" v-bind:class="{sumary: isSumaryCheck2(item.gubun), totSumary: isTotSumaryCheck2(item.gubun)}" style="font-weight: bold; text-align: left;">{{ item.collegeNm }}</md-table-cell>
                <md-table-cell md-label="전체인원" v-bind:class="{sumary: isSumaryCheck2(item.gubun), totSumary: isTotSumaryCheck2(item.gubun)}" style="text-align: right; font-weight: bold;">{{ formatter.getCurrency(item.totCnt) }}</md-table-cell>
                <md-table-cell md-label="납입자수" v-bind:class="{sumary: isSumaryCheck2(item.gubun), totSumary: isTotSumaryCheck2(item.gubun)}" style="text-align: right; font-weight: bold;">{{ formatter.getCurrency(item.payCnt) }}</md-table-cell>
                <md-table-cell md-label="남자" v-bind:class="{sumary: isSumaryCheck2(item.gubun), totSumary: isTotSumaryCheck2(item.gubun)}" style="text-align: right;">{{ formatter.getCurrency(item.manCnt) }}</md-table-cell>
                <md-table-cell md-label="여자" v-bind:class="{sumary: isSumaryCheck2(item.gubun), totSumary: isTotSumaryCheck2(item.gubun)}" style="text-align: right;">{{ formatter.getCurrency(item.femaleCnt) }}</md-table-cell>
                <md-table-cell md-label="미상" v-bind:class="{sumary: isSumaryCheck2(item.gubun), totSumary: isTotSumaryCheck2(item.gubun)}" style="text-align: right;">{{ formatter.getCurrency(item.etcCnt) }}</md-table-cell>
                <md-table-cell md-label="미상~" v-bind:class="{sumary: isSumaryCheck2(item.gubun), totSumary: isTotSumaryCheck2(item.gubun)}" style="text-align: right;">{{ formatter.getCurrency(item.cnt) }}</md-table-cell>
                <md-table-cell hidden></md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
      </div>
  </div>
  </div>
</template>

<script>

import moment from "moment";
import formatter from "@/kuaa/kuaa-formatter";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";


export default {

  components: {

  },

  created() {

  },

  data(){
    return {
      formatter,
      feeCdList : [
        {code: '10', codeNm: '일반회비'},
        {code: '11', codeNm: '평생회비'},
        {code: '12', codeNm: '분담금'}
      ],
      hakbunDataList: null,
      collegeDataList: null,
      wrkGubun: null,
      query: {
        feeCd: '10',
        feeYear: moment().subtract(1, 'year').format('YYYY')
      },
      query2: {
        feeCd: '10',
        feeYear: moment().subtract(1, 'year').format('YYYY')
      },
      totHakbunRow: {},
      totCollegeRow: {}
    }
  },

  methods: {

    searchQuery(wrkGubun) {
      this.wrkGubun = wrkGubun;
      let params = null;
      let callUrl = null;

      if(wrkGubun == 1){
        if(!this.query.feeYear){
          kuaaFnc.showSwal("회비통계", '회비년도는 필수 조회 조건입니다.');
          return false;
        }
        if(!this.query.feeCd){
          kuaaFnc.showSwal("회비통계", '회비구분은 필수 조회 조건입니다.');
          return false;
        }
        params = this.query;
        callUrl = URL_CONST.GET_STICS_FEE_HAKBUN_LIST;
      }else{
        if(!this.query2.feeYear){
          kuaaFnc.showSwal("회비통계", '회비년도는 필수 조회 조건입니다.');
          return false;
        }
        if(!this.query2.feeCd){
          kuaaFnc.showSwal("회비통계", '회비구분은 필수 조회 조건입니다.');
          return false;
        }
        params = this.query2;
        callUrl = URL_CONST.GET_STICS_FEE_COLLEGE_LIST;
      }

      kuaaApi.sendServer(
          callUrl,
          params,
          "post",
          (response) => {
            if(wrkGubun == 1) {
              response.data.data.contents.forEach((row, idx) => {

                if (row.gubun == '00-0') {
                  row.gubun = '미분류';
                } else if (row.gubun == '59-9') {
                  row.gubun = '60 이전';
                } else if (row.gubun == '69-9') {
                  row.gubun = '60 소계';
                } else if (row.gubun == '79-9') {
                  row.gubun = '70 소계';
                } else if (row.gubun == '89-9') {
                  row.gubun = '80 소계';
                } else if (row.gubun == '99-9') {
                  row.gubun = '90 소계';
                } else if (row.gubun == 'YY-SUM') {
                  row.gubun = '00 이후';
                } else if (row.gubun.indexOf('YY-') > -1) {
                  row.gubun = row.gubun.substr(3);
                } else if (row.gubun == 'ZZ-C') {
                  row.gubun = '학부 합계';
                  Object.assign(this.totHakbunRow, row);
                } else if (row.gubun == 'ZZ-G') {
                  row.gubun = '대학원 합계';
                  this.addHakbunSum(row);
                }
              });
              this.totHakbunRow.gubun = '합계';
              response.data.data.contents.push(this.totHakbunRow);
              this.hakbunDataList = response.data.data.contents;

            }else{
              let collegeCnt = 0;
              response.data.data.contents.forEach((row, idx) => {
                if(collegeCnt == 0 && row.collegeNm.indexOf('대학원') > -1)   collegeCnt = idx;
                if (row.gubun == 'ZZ-C') {
                  row.gubun = '학부 합계';
                  row.collegeNm = '';
                  Object.assign(this.totCollegeRow, row);
                } else if (row.gubun == 'ZZ-G') {
                  row.gubun = '대학원 합계';
                  row.collegeNm = '';
                  this.addCollegeSum(row);
                }
              });
              if(collegeCnt > 0) {
                response.data.data.contents.splice(collegeCnt, 0, response.data.data.contents[response.data.data.contents.length - 2]);
                response.data.data.contents.splice(response.data.data.contents.length - 2,1);
              }
              this.totCollegeRow.gubun = '합계';
              response.data.data.contents.push(this.totCollegeRow);
              this.collegeDataList = response.data.data.contents;
            }
          }
      );
    },
    addHakbunSum(data){
      this.totHakbunRow.totCnt += data.totCnt;
      this.totHakbunRow.payCnt += data.payCnt;
      this.totHakbunRow.manCnt += data.manCnt;
      this.totHakbunRow.femaleCnt += data.femaleCnt;
      this.totHakbunRow.etcCnt += data.etcCnt;
      this.totHakbunRow.jiroCnt += data.jiroCnt;
      this.totHakbunRow.transCnt += data.transCnt;
      this.totHakbunRow.creditCnt += data.creditCnt;
      this.totHakbunRow.newkorCnt += data.newkorCnt;
    },

    addCollegeSum(data){
      this.totCollegeRow.totCnt += data.totCnt;
      this.totCollegeRow.payCnt += data.payCnt;
      this.totCollegeRow.manCnt += data.manCnt;
      this.totCollegeRow.femaleCnt += data.femaleCnt;
      this.totCollegeRow.cnt += data.cnt;
    },


    isSumaryCheck(data){
      if(data.indexOf('소계') > -1 || data.indexOf('이전') > -1 || data.indexOf('이후') > -1)   return true;
    },
    isTotSumaryCheck(data){
      if(data == '합계' || data == '학부 합계')   return true;
    },

    isSumaryCheck2(data){
      if(data == '대학원 합계' || data == '학부 합계')   return true;
    },
    isTotSumaryCheck2(data){
      if(data == '합계')   return true;
    }
  }

}
</script>

<style>
  .sumary{
    background-color: #d3efd6;  /*#00acc1;*/
    font-weight: bold;
  }
  .totSumary{
    background-color: #81c784;  /*#00acc1;*/
    font-weight: bold;
  }
</style>